import gql from 'graphql-tag';

import clientWorkspaceLeadFragment from './client-workspace-lead-fragment';

const paginationClientWorkspaceLeadQuery = gql`
  ${clientWorkspaceLeadFragment}
  query PaginationClientWorkspaceLead(
      $filter: FilterPaginationClientWorkspaceLeadInput
      $page: Int
      $nextPage: Int
      $perPage: Int
      $sort: SortFindManyClientWorkspaceLeadInput
  ) {
      paginationClientWorkspaceLeadQuery(
          filter: $filter
          page: $page
          nextPage: $nextPage
          perPage: $perPage
          sort: $sort
      ) {
          items {
              ...ClientWorkspaceLeadFragment
          }
          pageInfo {
              currentPage
              perPage
              itemCount
              pageCount
              hasPreviousPage
              hasNextPage
          }
      }
  }
`;
export default paginationClientWorkspaceLeadQuery;
